// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    BREADCRUMB_CONTAINER: 'breadcrumb_container',
    BREADCRUMB_ELEMENT: 'breadcrumb_element',
    BREADCRUMB_POSITION: 'breadcrumb_position',
    BREADCRUMB_TITLE: 'breadcrumb_title',
};


export const breadCrumbModes = {
    light: 'light',
    dark: 'dark',
}
